import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { intlLocale } from "../lib";

// Etiquetas traducidas de los vocabularios del módulo (tipos, estados, modos,
// estados de cita, transiciones y categorías) más el locale de Intl. Todas con
// `defaultValue` = la clave cruda, para que un valor desconocido no rompa.
export function useMxLabels() {
  const { t, i18n } = useTranslation("common");
  return useMemo(() => {
    const k = (group: string) => (value?: string | null) =>
      value ? t(`mantenimiento.${group}.${value}`, { defaultValue: value }) : "—";
    return {
      t,
      locale: intlLocale(i18n.language),
      type: k("types"),
      status: k("statuses"),
      apptStatus: k("apptStatuses"),
      mode: k("modes"),
      transition: k("transitions"),
      category: k("categories"),
    };
  }, [t, i18n.language]);
}

export type MxLabels = ReturnType<typeof useMxLabels>;
